import { create } from 'zustand'

// UI selection only (survives navigation, not reloads). Holds real wave plan
// ids as given, across server pages and filter changes, until cleared.
export const useWaveRollupSelectionStore = create<{
  selectedPlanIds: string[]
  setSelectedPlanIds: (ids: string[]) => void
  selectPlans: (ids: string[], checked: boolean) => void
}>((set, get) => ({
  selectedPlanIds: [],
  setSelectedPlanIds: ids => set({ selectedPlanIds: [...new Set(ids)] }),
  selectPlans: (ids, checked) => {
    const selected = new Set(get().selectedPlanIds)
    ids.forEach(id => (checked ? selected.add(id) : selected.delete(id)))
    set({ selectedPlanIds: [...selected] })
  },
}))
